/**
 * @prettier
 * @flow
 */
import { FormHelperText } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormEmailField } from 'src/components/form/contact/FormEmailField';
import { FormPhoneNumberField } from 'src/components/form/contact/FormPhoneNumberField';
import { removeNulls } from 'src/utils/removeNulls';
import { translate } from 'src/utils/translate/translate';

export function FormContactDetailsField({ name, required }: Props) {
    const { errors } = useFormContext();

    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Typography variant='overline' color='textSecondary'>
                    {translate('Contact Details')}
                </Typography>
                <FormEmailField name={name} rules={{ required }} />
            </Grid>
            <Grid item xs={12}>
                <FormPhoneNumberField name={name} rules={{ required }} />
            </Grid>
            <FormHelperText error>{removeNulls([errors[name]?.['email']?.message, errors[name]?.['phoneNumber']?.message]).join(', ')}</FormHelperText>
        </Grid>
    );
}

type Props = {|
    name: string,
    required?: boolean,
|};
